import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.688 2.588c.26-.226.594-.338.923-.338H13.39c.329 0 .662.112.923.338.264.23.438.565.438.941V14a.75.75 0 0 1-1.084.672L9.8 12.75H2.611c-.329 0-.662-.112-.923-.338a1.246 1.246 0 0 1-.438-.941V3.529c0-.376.174-.712.438-.94Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgMessage = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgMessage;
